window.VAE = window.VAE || {};

VAE.DOM = (function() {
  'use strict';

  const elementsToSkip = [
    'BR', 'HR', 'META', 'LINK', 'SCRIPT', 'STYLE', 'NOSCRIPT',
    'PATH', 'CIRCLE', 'RECT', 'POLYGON', 'ELLIPSE', 'LINE',
    'SOURCE', 'TRACK', 'WBR', 'PARAM', 'AREA'
  ];

  const widgetId = 'vae-widget-container';
  
  const pendingSet = new Set();
  let uniqueCounter = 1;

  // function ensureStructureId(el) {
  //   if (el.id) {
  //     pendingSet.add(el.id);
  //     return el.id;
  //   }
  //   const newId = `vae-${uniqueCounter++}`;
  //   el.id = newId;
  //   pendingSet.add(newId);
  //   return newId;
  // }

  function ensureStructureId(el) {
    const newId = `vae-${uniqueCounter++}`;
    el.setAttribute('data-vae-id', newId);
    pendingSet.add(newId);
    return newId;
  }

  function generateUniqueIds(rootElement) {
    if (!rootElement) {
      console.error('VAE.DOM.generateUniqueIds: Fehler - Kein rootElement übergeben');
      return 0;
    }
    const elements = rootElement.querySelectorAll('*');
    elements.forEach(el => {
      if (el.nodeType === Node.ELEMENT_NODE) {
        ensureStructureId(el);
      }
    });
    return elements.length;
  }

  function getElements(selector) {
    try {
      if (!selector) {
        console.warn('VAE.DOM: Empty selector provided');
        return [];
      }
      
      if (selector.includes(',')) {
        const selectors = selector.split(',').map(s => s.trim());
        const elements = [];
        selectors.forEach(s => {
          try {
            const found = document.querySelectorAll(s);
            found.forEach(el => elements.push(el));
          } catch (err) {
            console.warn(`VAE.DOM: Invalid sub-selector: ${s}`, err);
          }
        });
        return elements;
      } else {
        return Array.from(document.querySelectorAll(selector));
      }
    } catch (error) {
      console.error('VAE.DOM: Invalid selector:', selector, error);
      return [];
    }
  }

  function addAttribute(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (typeof params.attribute === 'string' && typeof params.value === 'string') {
            element.setAttribute(params.attribute, params.value);
          } else if (Array.isArray(params.attribute) && Array.isArray(params.value)) {
            for (let i = 0; i < params.attribute.length; i++) {
              element.setAttribute(params.attribute[i], params.value[i]);
            }
          } else if (params.name && params.value) {
            element.setAttribute(params.name, params.value);
          } else {
            throw new Error('Invalid parameters for addAttribute');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error setting attribute on element:`, elemError, element);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function removeAttribute(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (typeof params.attribute === 'string') {
            element.removeAttribute(params.attribute);
          } else if (Array.isArray(params.attributes)) {
            params.attributes.forEach(attr => {
              element.removeAttribute(attr);
            });
          } else if (params.attr) {
            element.removeAttribute(params.attr);
          } else {
            throw new Error('Invalid parameters for removeAttribute');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error removing attribute from element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function setStyle(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.property && params.value !== undefined) {
            element.style[params.property] = params.value;
            
            if (params.property2 && params.value2 !== undefined) {
              element.style[params.property2] = params.value2;
            }
          } else {
            let propertySet = false;
            Object.keys(params).forEach(prop => {
              if (['property', 'value', 'property2', 'value2'].indexOf(prop) === -1) {
                element.style[prop] = params[prop];
                propertySet = true;
              }
            });
            
            if (!propertySet) {
              throw new Error('No valid style properties found in parameters');
            }
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error changing style of element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function setContent(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.newSrc && element.tagName === 'IMG') {
            element.src = params.newSrc;
          } else if (params.newContent !== undefined) {
            element.innerHTML = params.newContent;
          } else if (params.content !== undefined) {
            element.innerHTML = params.content;
          } else {
            throw new Error('Missing required parameter: newSrc, newContent, or content');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error changing content of element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function removeElement(selector) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (element.parentNode) {
            element.parentNode.removeChild(element);
          } else {
            throw new Error('Element has no parent node');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error removing element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function addElement(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      if (!params.newTag) {
        return { success: false, error: 'Missing required parameter: newTag' };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          const newElement = document.createElement(params.newTag);
          
          if (params.content) {
            newElement.innerHTML = params.content;
          }
          
          if (params.text) {
            newElement.textContent = params.text;
          }
          
          if (params.attributes) {
            Object.keys(params.attributes).forEach(attr => {
              try {
                newElement.setAttribute(attr, params.attributes[attr]);
              } catch (attrError) {
                console.warn(`VAE.DOM: Error setting attribute ${attr}:`, attrError);
              }
            });
          }
          
          if (params.html) {
            newElement.innerHTML = params.html;
          }
          
          const position = params.position || 'append';
          
          try {
            if (position === 'firstChild') {
              element.insertBefore(newElement, element.firstChild);
            } else if (position === 'afterbegin') {
              element.insertBefore(newElement, element.firstChild);
            } else if (position === 'beforeend' || position === 'append') {
              element.appendChild(newElement);
            } else if (position === 'after') {
              if (element.parentNode) {
                element.parentNode.insertBefore(newElement, element.nextSibling);
              } else {
                throw new Error('Reference element has no parent node');
              }
            } else if (position === 'before' || position === 'first') {
              if (element.parentNode) {
                element.parentNode.insertBefore(newElement, element);
              } else {
                throw new Error('Reference element has no parent node');
              }
            } else {
              throw new Error(`Invalid position value: ${position}`);
            }
          } catch (posError) {
            console.warn(`VAE.DOM: Error positioning new element:`, posError);
            success = false;
            return;
          }
          
          if (params.reference) {
            try {
              const refElement = document.querySelector(params.reference);
              if (refElement && refElement.parentNode) {
                refElement.parentNode.insertBefore(newElement, refElement.nextSibling);
              } else {
                throw new Error(`Reference element not found: ${params.reference}`);
              }
            } catch (refError) {
              console.warn(`VAE.DOM: Error using reference element:`, refError);
              success = false;
            }
          }
          
          if (params.parent) {
            try {
              const parentElement = document.querySelector(params.parent);
              if (parentElement) {
                parentElement.appendChild(newElement);
              } else {
                throw new Error(`Parent element not found: ${params.parent}`);
              }
            } catch (parentError) {
              console.warn(`VAE.DOM: Error using parent element:`, parentError);
              success = false;
            }
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error adding new element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function wrap(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.parentTag) {
            const parentElement = document.createElement(params.parentTag);
            element.parentNode.insertBefore(parentElement, element);
            parentElement.appendChild(element);
          } else if (params.newParent) { 
            const wrapper = document.createElement(params.newParent);
            
            if (params.legend && params.newParent === 'fieldset') {
              const legend = document.createElement('legend');
              legend.textContent = params.legend;
              wrapper.appendChild(legend);
            }
            
            element.parentNode.insertBefore(wrapper, element);
            wrapper.appendChild(element);
          } else {
            throw new Error('Missing required parameter: parentTag or newParent');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error wrapping element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function wrapInner(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.wrapperTag) {
            const wrapper = document.createElement(params.wrapperTag);
            
            while (element.firstChild) {
              wrapper.appendChild(element.firstChild);
            }
            
            element.appendChild(wrapper);
          } else {
            throw new Error('Missing required parameter: wrapperTag');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error wrapping inner content:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function moveElement(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.after) {
            const targetElement = document.querySelector(params.after);
            if (targetElement) {
              targetElement.parentNode.insertBefore(element, targetElement.nextSibling);
            } else {
              throw new Error(`Target element not found: ${params.after}`);
            }
          } else if (params.before) {
            const targetElement = document.querySelector(params.before);
            if (targetElement) {
              targetElement.parentNode.insertBefore(element, targetElement);
            } else {
              throw new Error(`Target element not found: ${params.before}`);
            }
          } else if (params.newParent) {
            const newParent = document.querySelector(params.newParent);
            if (newParent) {
              newParent.appendChild(element);
            } else {
              throw new Error(`New parent element not found: ${params.newParent}`);
            }
          } else {
            throw new Error('Missing required parameter: after, before, or newParent');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error moving element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function replaceElement(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.newMarkup) {
            const temp = document.createElement('div');
            temp.innerHTML = params.newMarkup;
            
            const parent = element.parentNode;
            if (!parent) {
              throw new Error('Element has no parent node');
            }
            
            while (temp.firstChild) {
              parent.insertBefore(temp.firstChild, element);
            }
            
            parent.removeChild(element);
          } else {
            throw new Error('Missing required parameter: newMarkup');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error replacing element:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  
  function addJS(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      
      let success = true;
      elements.forEach(element => {
        try {
          if (params.event && params.action) {
            const eventParts = params.event.split('.');
            const eventType = eventParts[0]; 
            const key = eventParts.length > 1 ? eventParts[1] : null; 
            
            element.addEventListener(eventType, function(e) {
              if (key && e.key && e.key.toLowerCase() !== key.toLowerCase()) {
                return; 
              }
              
              if (params.action === 'click') {
                e.preventDefault();
                element.click();
              } else if (params.action === 'closeLightbox') {
                e.preventDefault();
                const closeButton = element.querySelector('.close, .close-button, [aria-label="Close"]');
                if (closeButton) {
                  closeButton.click();
                } else {
                  element.style.display = 'none';
                }
              }
            });
          } else {
            throw new Error('Missing required parameters: event and action');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: Error adding JS event handler:`, elemError);
          success = false;
        }
      });
      
      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  function changeTag(selector, params) {
    try {
      const elements = getElements(selector);
      if (!elements.length) {
        return { success: false, error: `No elements found matching selector: ${selector}` };
      }
      if (!params.newTag) {
        return { success: false, error: 'Missing required parameter: newTag' };
      }

      let success = true;
      elements.forEach(oldElement => {
        try {
          const newElement = document.createElement(params.newTag);

          for (let i = 0; i < oldElement.attributes.length; i++) {
            const attr = oldElement.attributes[i];
            try {
              newElement.setAttribute(attr.name, attr.value);
            } catch (attrError) {
               console.warn(`VAE.DOM: changeTag - Error copying attribute ${attr.name}:`, attrError);
            }
          }

          while (oldElement.firstChild) {
            newElement.appendChild(oldElement.firstChild);
          }

          if (oldElement.parentNode) {
            oldElement.parentNode.replaceChild(newElement, oldElement);
          } else {
            throw new Error('Element has no parent node, cannot replace.');
          }
        } catch (elemError) {
          console.warn(`VAE.DOM: changeTag - Error changing tag for element:`, elemError, oldElement);
          success = false; 
        }
      });

      return { success };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  return {
    generateUniqueIds,
    getElements,
    addAttribute,
    removeAttribute,
    setStyle,
    setContent,
    removeElement,
    addElement,
    moveElement,
    wrap,
    wrapInner,
    replaceElement,
    addJS,
    changeTag,
    ensureStructureId,
    pendingSet
  };
})();